import React, { useContext } from "react";
import TextField from "@mui/material/TextField";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import moment from "moment";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import useFormikDatePicker from "./useFormikDatePicker";
import FormikControlContext from "../../../Contexts/FormikControlContext";
// import { DatePicker } from "@mui/x-date-pickers";
// import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

// TODO: Make it generic and Use New Date Field
const CustomDatePicker = ({ field }) => {
  const { name, value } = field;
  const formikField = useContext(FormikControlContext);
  const { readOnly, defaultValue } = formikField;

  const { handleChange, handleOnAccept } = useFormikDatePicker();

  // const handleChange = (newValue) => {
  //   form.setFieldValue(field.name, newValue);
  // };
  // return (
  //   <LocalizationProvider dateAdapter={AdapterMoment}>
  //     <DemoContainer
  //       components={[
  //         "DatePicker",
  //         "MobileDatePicker",
  //         "DesktopDatePicker",
  //         "StaticDatePicker",
  //       ]}
  //     >
  //       <DatePicker
  //         onChange={handleChange}
  //         renderInput={(props) => <TextField {...props} />}
  //       />
  //     </DemoContainer>
  //   </LocalizationProvider>
  // );
  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <MobileDatePicker
        disableFuture
        id={name}
        name={name}
        value={value}
        //minDate={minDate}
        // minDate={
        //   field.name === `primaryDetail[${props.arrayindex}].birthDt` ||
        //   field.name === `primaryDetail[${props.arrayindex}].dob`
        //     ? minDateOfBirth
        //     : minDate
        // }
        //maxDate={maxDate ? maxDate : moment(localStorage.getItem("date"), 'DD-MM-YYYY')}
        // maxDate={
        //   field.name === `primaryDetail[${props.arrayindex}].birthDt` ||
        //   field.name === `primaryDetail[${props.arrayindex}].dob`
        //     ? maxDate
        //     : null
        // }
        inputFormat="DD-MMMM-YYYY"
        // readOnly={readOnly}
        disabled={readOnly}
        // {...field}
        onChange={(newValue) => {
          handleChange(name, newValue);
        }}
        onAccept={(newValue) => {
          handleOnAccept(name, newValue);
        }}
        renderInput={(params) => {
          return (
            <TextField
              name={name}
              id={name}
              sx={{
                "& legend": {
                  display: "none",
                },
                "& .MuiOutlinedInput-root": {
                  "&.Mui-error fieldset ": {
                    borderColor: "rgba(0, 0, 0, 0.23) !important", // default
                  },
                },
              }}
              fullWidth
              {...params}
            />
          );
        }}
      />
    </LocalizationProvider>
  );
};

export default CustomDatePicker;
